import { forwardRef } from 'react';

import { IconProps } from '@sternum/web/icons/icons.types';

export const VirusNotCheckedIcon = forwardRef<SVGSVGElement, IconProps>(function VirusNotCheckedIcon(
  { color = '', height = 12, width = 12, ...props },
  ref,
) {
  return (
    <svg
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.7534 3.06114C10.9169 3.7433 10.9914 4.63377 10.9995 5.80733C11.0004 5.93401 10.9995 5.94391 10.998 5.95709L10.998 5.95773C10.9964 5.97175 10.9956 5.97899 10.9718 6.08376C10.2164 9.39741 7.50021 10.6544 6.29523 11.0604C6.2291 11.0827 6.18858 11.0963 6.15352 11.1071C6.12152 11.1169 6.10596 11.1207 6.09808 11.1224C6.09787 11.1225 6.09763 11.1225 6.09734 11.1226C6.092 11.1238 6.07174 11.1284 6 11.1284C5.92826 11.1284 5.908 11.1238 5.90266 11.1226C5.90237 11.1225 5.90213 11.1225 5.90192 11.1224C5.89403 11.1207 5.87848 11.1169 5.84648 11.1071C5.81142 11.0963 5.7709 11.0827 5.70477 11.0604C4.49979 10.6544 1.78364 9.39741 1.02825 6.08376C1.00436 5.97898 1.00357 5.97175 1.00204 5.95772L1.00197 5.95708C1.00053 5.94391 0.99958 5.93401 1.00046 5.80733C1.00856 4.63377 1.0831 3.7433 1.24658 3.06114C1.4088 2.38423 1.64523 1.97073 1.92953 1.69716C2.49201 1.15588 3.54978 0.871553 6 0.871553C8.45022 0.871553 9.50799 1.15588 10.0705 1.69716C10.3548 1.97074 10.5912 2.38424 10.7534 3.06114ZM11.9936 6.0398C11.9864 6.10562 11.9751 6.15495 11.9526 6.2536C11.1026 9.98224 8.0191 11.414 6.65585 11.8733C6.4052 11.9578 6.27988 12 6 12C5.72012 12 5.5948 11.9578 5.34415 11.8733C3.9809 11.414 0.897355 9.98224 0.0473593 6.2536C0.0248722 6.15496 0.0136268 6.10562 0.00642612 6.0398C-0.000773593 5.97398 -0.000377789 5.91668 0.000413819 5.80208C0.0333724 1.03158 1.13522 -3.70642e-07 6 0C10.8648 3.70643e-07 11.9666 1.03158 11.9996 5.80209C12.0004 5.91668 12.0008 5.97398 11.9936 6.0398Z"
        fill={color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.87787 4.80798C8.0588 4.62616 8.03634 4.35094 7.82771 4.19326C7.61908 4.03557 7.30327 4.05515 7.12234 4.23697L6.00002 5.36484L4.87769 4.23697C4.69676 4.05515 4.38095 4.03557 4.17232 4.19326C3.96369 4.35094 3.94123 4.62616 4.12216 4.80798L5.33815 6.02997L4.12216 7.25196C3.94123 7.43378 3.96369 7.709 4.17232 7.86669C4.38095 8.02437 4.69676 8.0048 4.87769 7.82297L6.00002 6.69511L7.12234 7.82297C7.30327 8.0048 7.61908 8.02437 7.82771 7.86669C8.03634 7.709 8.0588 7.43378 7.87787 7.25196L6.66188 6.02997L7.87787 4.80798Z"
        fill={color || 'currentColor'}
      />
    </svg>
  );
});
